import type { CartCurrency } from '../types/cart';

const CART_PRICE_LOCALES: Record<CartCurrency, string> = {
  ARS: 'es-AR',
  CLP: 'es-CL',
  COP: 'es-CO',
  MXN: 'es-MX',
};

export const formatCartPrice = (amount: number, currency: CartCurrency): string => {
  const sign = amount < 0 ? '-' : '';
  const value = new Intl.NumberFormat(CART_PRICE_LOCALES[currency], {
    maximumFractionDigits: 0,
  }).format(Math.abs(amount));

  return `${currency} ${sign}${value}`;
};

export const getCartPriceParts = (
  amount: number,
  currency: CartCurrency,
): { currencyLabel: CartCurrency; amountLabel: string } => {
  const formattedPrice = formatCartPrice(amount, currency);
  const amountLabel = formattedPrice.replace(`${currency} `, '');

  return { currencyLabel: currency, amountLabel };
};
